import { Component, Input } from '@angular/core';
import { TranslationService } from '../../../../translations';

@Component({
    selector: 'contract-renewal-date',
    template: `
        @if (contractRenewalDate) {
            <div>
                <div class="title">
                    {{
                        TR.key(
                            'subscription-manager.overview-contract-renewal-date'
                        )
                    }}
                </div>
                <dl class="inlineDL">
                    <p>
                        <dd class="content">{{ contractRenewalDate }}</dd>
                    </p>
                </dl>
            </div>
        }
    `,
    styleUrls: ['../overview.component.less'],
    standalone: false
})
export class ContractRenewalDateComponent {
    @Input()
    contractRenewalDate: string;
    constructor(public TR: TranslationService) {}
}
